package guide.kuki.app.engine

/**
 * A geographic coordinate point storing latitude and longitude,
 * with pre-computed array forms for use in geometry calculations.
 */
data class Coords(val lat: Double, val lon: Double) {
    /** [lat, lon] order — used for distance calculations. */
    val latlon: DoubleArray = doubleArrayOf(lat, lon)

    /** [lon, lat] order — used for polygon containment tests (x=lon, y=lat). */
    val lonlat: DoubleArray = doubleArrayOf(lon, lat)

    constructor(latlon: DoubleArray) : this(latlon[0], latlon[1])

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is Coords) return false
        return lat == other.lat && lon == other.lon
    }

    override fun hashCode(): Int {
        var result = lat.hashCode()
        result = 31 * result + lon.hashCode()
        return result
    }
}
